import React from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '../../context/ThemeContext';

const SectionHeader = ({ 
  title, 
  subtitle, 
  className = '',
  align = 'center',
  variant, // 'light' or 'dark' - if not provided, uses theme
  withDivider = false, // Add decorative divider lines
}) => {
  const { theme } = useTheme();
  const effectiveVariant = variant || theme;
  
  const alignClasses = {
    center: 'text-center',
    left: 'text-left',
    right: 'text-right',
  };

  const textColors = {
    light: {
      title: 'text-afsc-charcoal',
      subtitle: 'text-afsc-charcoal/70',
    },
    dark: {
      title: 'text-white',
      subtitle: 'text-white/70',
    },
  };

  const colors = textColors[effectiveVariant];

  return (
    <motion.div
      className={`mb-12 md:mb-16 ${alignClasses[align]} ${className}`}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
    >
      {withDivider && align === 'center' && (
        <div className="flex items-center justify-center mb-6">
          <div className={`h-px w-12 ${effectiveVariant === 'dark' ? 'bg-afsc-gold/60' : 'bg-afsc-gold/80'}`} />
          <div className={`w-2 h-2 rounded-full mx-3 ${effectiveVariant === 'dark' ? 'bg-afsc-gold' : 'bg-afsc-gold'}`} />
          <div className={`h-px w-12 ${effectiveVariant === 'dark' ? 'bg-afsc-gold/60' : 'bg-afsc-gold/80'}`} />
        </div>
      )}
      {title && (
        <h2 className={`text-4xl md:text-5xl lg:text-6xl font-heading font-bold mb-4 ${colors.title}`}>
          {title}
        </h2>
      )}
      {subtitle && (
        <p className={`text-lg md:text-xl ${colors.subtitle} max-w-3xl ${align === 'center' ? 'mx-auto' : ''}`}>
          {subtitle}
        </p>
      )}
    </motion.div>
  );
};

export default SectionHeader;

